import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';

@AutoUnsubscribe()
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  public redirect = environment.applyRedirect;

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService
  ) {}

  public scrollTo(elementId: string): void {
    (document.querySelector(`#${elementId}`) as Element).scrollIntoView({
      behavior: 'smooth',
    });
  }

  ngOnInit(): void {
    this.eventService.mobileDisplayLogoToolbar.next(false);

    this.route.params.subscribe((params) => {
      if (params) {
        if (params.idNumber) {
          this.eventService.prefillContactSet({ idNumber: params.idNumber });
        }
      }
    });
  }

  ngOnDestroy(): void {}
}
